module.exports = __webpack_public_path__ + "static/img/main.e7402ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/top_message/main.png
// module id = RZqK
// module chunks = 0